import React, { useState } from "react"
import moment from 'moment'
import { MdOutlineDateRange } from "react-icons/md"
import Modal from './index'
import Button from "../Form/Button"
import FormGroup from "../Form/FormGroup"
import FormGroupInline from '../Form/FormGroupInline'
import DatePicker from "../Form/DatePicker"
import { useEffect } from "react"

const ModalAddPeriodTest = ({ expires_at = {}, onSubmit = () => { }, closeModal = () => { } }) => {
    const [minDate, setMinDate] = useState()
    const [newDate, setNewDate] = useState()

    useEffect(() => {
        if (expires_at) {
            setMinDate(moment().isBefore(expires_at) ? moment(expires_at).startOf('day').add(1, 'days') : moment().startOf('day'))
        }
    }, [expires_at])

    const handleChangeValue = (value) => {
        setNewDate(value)
    }

    const handleSubmit = () => {
        onSubmit(newDate)
    }

    return (
        <Modal
            icon={<MdOutlineDateRange />}
            title={"Liberar período de teste"}
            description={"Defina até que data o período de teste será liberado!"}
            closeModal={closeModal}
        >
            <FormGroup>
                <FormGroup labelText="Expiração atual">
                    <span>{moment(expires_at).format("DD/MM/YYYY") || "-"}</span>
                </FormGroup>
                <FormGroup labelText="Liberar teste até">
                    <DatePicker min={minDate} max={moment().startOf('day').add(90, 'days')} multiple={false} name="Liberar teste até" onChange={handleChangeValue} dateStart={newDate} />
                </FormGroup>
                <FormGroupInline>
                    <Button variant='primary' onClick={handleSubmit}>Salvar</Button>
                    <Button variant='secondary' onClick={closeModal}>Cancelar</Button>
                </FormGroupInline>
            </FormGroup>
        </Modal >
    )
}

export default ModalAddPeriodTest
